import React from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl';

import Moment from 'moment'
import { extendMoment } from 'moment-range';

import List from '../list/list'
import Button from '../button/button'
import './calendar.styl'
import '../template/table-list.styl'

import CalendarViewList from './view/view-list'
import CalendarViewNanoList from './view/view-nanoList'
import CalendarViewBloc from './view/view-Bloc'

import {NANOLIST_VIEW, BLOC_VIEW, LIST_VIEW} from './calendar-views'

const moment = extendMoment(Moment);

export const OPEN_CALENDAR_MONTH = 'app/component/calendar/OPEN_CALENDAR_MONTH'

class Calendar extends React.Component {
    static propTypes = {
        collection: PropTypes.array.isRequired,
        month: PropTypes.instanceOf(moment),
        view: PropTypes.string
    }

    state = {}

    setView(view){
        return e => {
            this.state.view = view;
            this.setState(this.state);
        }
    }

    viewFactory(view, day, collection) {
        switch(view) {
            case NANOLIST_VIEW: return <CalendarViewNanoList {...{day, collection}} />
            case BLOC_VIEW: return <CalendarViewBloc {...{day, collection}} />
            case LIST_VIEW: return <CalendarViewList {...{day, collection}} />
            default: return <CalendarViewList {...{day, collection}} />
        }
    }

    opentMonth() {
        console.log('Calendar WRITE THE DISPATCH FUNCTION')
        // const {month, dispatch} = this.props
        // dispatch({type: OPEN_CALENDAR_MONTH, month, user})
    }

    render() {
        const {view = this.props.view} = this.state
        const {month, collection} = this.props
        const startOf = moment(month).startOf('month')
        const endOf = moment(month).endOf('month')
        const daysRange = moment.range(startOf, endOf)

        const days = Array.from(daysRange.by('days'))
        const daysItemList = days.map(day => this.viewFactory(view, day, collection))

        return <div className="calendar">
            <label className="calendar-title">
                <Button onClick={this.opentMonth.bind(this)} ><Label>{'app.' + month.format('MMMM').toLowerCase() }</Label>{month.format('YYYY')}</Button>
            </label>
            <List collection={daysItemList}/>
        </div>
    }
}

function mapStateToProps(state) {
    return {
        ...state
    }
}

export default connect(mapStateToProps)(injectIntl(Calendar))
